// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { CartProvider } from './context/CartContext';

// Páginas principales
import Home from './components/pages/Home';
import About from './components/pages/About';
import Services from './components/pages/Services';
import SpareParts from './components/pages/SpareParts';
import Contact from './components/pages/Contact';
import Machinery from './components/pages/Machinery';
import Industries from './components/pages/Industries';
import NotFound from './components/pages/NotFound';
import PrivacyPolicy from './components/pages/PrivacyPolicy';
import TermsConditions from './components/pages/TermsConditions';
import Cart from './components/pages/Cart';

// Páginas de maquinaria específica
import BrazoArticulado from './components/pages/machinery/BrazoArticulado';
import CargadoresFrontales from './components/pages/machinery/CargadoresFrontales';
import Compactadoras from './components/pages/machinery/Compactadoras';
import Excavadoras from './components/pages/machinery/Excavadoras';
import ManipuladoresTelescopicos from './components/pages/machinery/ManipuladoresTelescopicos';
import Minicargadores from './components/pages/machinery/Minicargadores';
import Miniexcavadoras from './components/pages/machinery/Miniexcavadoras';
import Montacargas from './components/pages/machinery/Montacargas';
import PlataformaAltura from './components/pages/machinery/PlataformaAltura';
import Retroexcavadoras from './components/pages/machinery/Retroexcavadoras';
import Teletruk from './components/pages/machinery/Teletruk';

// Páginas de industrias específicas
import Agricultura from './components/pages/industries/Agricultura';
import Construccion from './components/pages/industries/Construccion';
import Industrial from './components/pages/industries/Industrial';
import Oem from './components/pages/industries/Oem';
import ReciclajeResiduos from './components/pages/industries/ReciclajeResiduos';

// Componentes comunes
import Navbar from './components/common/Navbar';
import Footer from './components/common/Footer';
import ScrollToTop from './components/common/ScrollToTop';

function App() {
  return (
    <CartProvider>
      <Router>
        <ScrollToTop />
        <div className="app">
          <Navbar />
          <main className="w-full pt-20">
            <Routes>
              {/* Rutas principales */}
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/spare-parts" element={<SpareParts />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-conditions" element={<TermsConditions />} />
              <Route path="/machinery" element={<Machinery />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/contact" element={<Contact />} />

              {/* Rutas de maquinaria - Detalle individual */}
              <Route path="/machinery/brazoarticulado" element={<BrazoArticulado />} />
              <Route path="/machinery/cargadoresfrontales" element={<CargadoresFrontales />} />
              <Route path="/machinery/compactadoras" element={<Compactadoras />} />
              <Route path="/machinery/excavadoras" element={<Excavadoras />} />
              <Route path="/machinery/manipuladorestelescopicos" element={<ManipuladoresTelescopicos />} />
              <Route path="/machinery/minicargadores" element={<Minicargadores />} />
              <Route path="/machinery/miniexcavadoras" element={<Miniexcavadoras />} />
              <Route path="/machinery/montacargas" element={<Montacargas />} />
              <Route path="/machinery/plataformadealtura" element={<PlataformaAltura />} />
              <Route path="/machinery/retroexcavadora" element={<Retroexcavadoras />} />
              <Route path="/machinery/teletruk" element={<Teletruk />} />

              {/* Rutas de industrias */}
              <Route path="/industries" element={<Industries />} />

              {/* Rutas de industrias - Detalle individual */}
              <Route path="/industries/agricultura" element={<Agricultura />} />
              <Route path="/industries/construccion" element={<Construccion />} />
              <Route path="/industries/industrial" element={<Industrial />} />
              <Route path="/industries/oem" element={<Oem />} />
              <Route path="/industries/reciclaje-y-residuos" element={<ReciclajeResiduos />} />

              {/* Ruta 404 - Siempre al final */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </CartProvider>
  );
}

export default App;